module.exports = __webpack_public_path__ + "static/media/Koek.022a542a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Koek.jpg
// module id = 317
// module chunks = 0